/* istanbul ignore file */
// This file was generated by figma/utils.mjs
import React, { FunctionComponent } from 'react'

export const Notifications: FunctionComponent = (): JSX.Element => (
  <React.Fragment>
    <path
      d='M14 20C14.5523 20 15 20.4477 15 21C15 21.5523 14.5523 22 14 22H9.99999C9.44772 22 9 21.5523 8.99999 21C8.99999 20.4477 9.44772 20 9.99999 20H14ZM12 2C15.0235 2.00012 17.6373 4.11077 18.2744 7.06641L20.4775 17.2891L20.4951 17.4004C20.5212 17.6604 20.4443 17.9222 20.2783 18.1279C20.0885 18.3631 19.8022 18.5 19.5 18.5H4.49999C4.1978 18.5 3.91152 18.363 3.72167 18.1279C3.53202 17.8929 3.45883 17.5843 3.52246 17.2891L5.72558 7.06641C6.36254 4.11055 8.97628 2 12 2ZM12 4C9.91859 4 8.11925 5.45267 7.68066 7.4873L5.73828 16.5H18.2617L16.3193 7.4873C15.8808 5.45269 14.0813 4.00012 12 4Z'
      fill='currentColor'
    />
  </React.Fragment>
)
